export default {
  'menu.welcome': 'স্বাগতম',
  'menu.home': 'নীড়',
  'menu.login': 'প্রবেশ',

  // সিস্টেম ম্যানেজমেন্ট মডিউল
  'menu.system': 'সিস্টেম ম্যানেজমেন্ট',
  'menu.system.welcome': 'সিস্টেম হোম',
  'menu.system.dict': 'অভিধান ম্যানেজমেন্ট',
  'menu.system.menu': 'মেনু ম্যানেজমেন্ট',
  'menu.system.role': 'ভূমিকা ম্যানেজমেন্ট',
  'menu.system.noAuth': 'প্রমাণীকরণ ছাড়া ইন্টারফেস',

  // সংগঠন ম্যানেজমেন্ট মডিউল
  'menu.organization': 'সংগঠন ম্যানেজমেন্ট',
  'menu.organization.orgDept': 'বিভাগ ম্যানেজমেন্ট',
  'menu.organization.orgPost': 'পদ ম্যানেজমেন্ট',
  'menu.organization.orgTree': 'সংগঠনের গঠন',
  'menu.organization.employee': 'কর্মচারী ম্যানেজমেন্ট',

  // ডিভাইস ম্যানেজমেন্ট মডিউল
  'menu.device': 'ডিভাইস ম্যানেজমেন্ট',
  'menu.device.deviceModel': 'ডিভাইস মডেল',
  'menu.device.deviceSupplier': 'ডিভাইস সরবরাহকারী',
  'menu.device.deviceGateway': 'ডিভাইস গেটওয়ে',
  'menu.device.deviceTerminal': 'ডিভাইস টার্মিনাল',
  'menu.device.deviceManagement': 'ডিভাইস ম্যানেজমেন্ট',

  // ইভেন্ট ম্যানেজমেন্ট মডিউল
  'menu.event': 'ইভেন্ট ম্যানেজমেন্ট',
  'menu.event.eventRecord': 'ইভেন্ট রেকর্ড',
  'menu.event.eventOrder': 'ইভেন্ট অর্ডার',
  'menu.event.eventOrderNode': 'অর্ডার নোড',
  'menu.event.eventReceiver': 'ইভেন্ট রিসিভার',
  'menu.event.resourceFile': 'রিসোর্স ফাইল',

  // প্যাকেজ ম্যানেজমেন্ট মডিউল
  'menu.package': 'প্যাকেজ ম্যানেজমেন্ট',
  'menu.package.myPackage': 'আমার প্যাকেজ',
  'menu.package.subPackage': 'উপ প্যাকেজ',

  // ব্যবহারকারী ম্যানেজমেন্ট
  'menu.user': 'ব্যবহারকারী ম্যানেজমেন্ট',

  // ভিডিও ফিউশন মডিউল
  'menu.video': 'ভিডিও ফিউশন',
  'menu.video.preview': 'প্রকৃত সময়ে প্রাকদর্শন',
  'menu.video.playback': 'ইতিহাস প্লেব্যাক',
  'menu.video.recording': 'হস্ত নির্মিত রেকর্ডিং',
};
